module.exports = __webpack_public_path__ + "static/media/Whisperflo.0cd91f4a.pdf";